export default {"src":"/_next/static/media/chequered_flag_basic_icon_white.88c5ff29.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};